export default class KaraokeOrderPriceInfo {

  public basicAmount: number;
  public royaltyOptionAmount: number;
  public onvocalOptionAmount: number;
  public physicalOptionAmount: number;
  public duetOptionAmount: number;
  public introClickOptionAmount: number;


  constructor(
    basicAmount: number,
    royaltyOptionAmount: number,
    onvocalOptionAmount: number,
    duetOptionAmount: number,
    physicalOptionAmount: number,
    introClickOptionAmount: number,
  ) {
    this.basicAmount = basicAmount;
    this.royaltyOptionAmount = royaltyOptionAmount;
    this.onvocalOptionAmount = onvocalOptionAmount;
    this.physicalOptionAmount = physicalOptionAmount;
    this.duetOptionAmount = duetOptionAmount;
    this.introClickOptionAmount = introClickOptionAmount;
  }

  get basicAmountWithoutTax() {
    return this.basicAmount / 1.1;
  }

  get royaltyOptionAmountWithoutTax() {
    return this.royaltyOptionAmount / 1.1;
  }

  get onvocalOptionAmountWithoutTax() {
    return this.onvocalOptionAmount / 1.1;
  }

  get physicalOptionAmountWithoutTax() {
    return this.physicalOptionAmount / 1.1;
  }

  get duetOptionAmountWithoutTax() {
    return this.duetOptionAmount / 1.1;
  }

  get introClickOptionAmountWithoutTax() {
    return this.introClickOptionAmount / 1.1;
  }

  getPlanAmount(data: {
    royalty_order: string,
    onvocal: string,
    physical: string,
    duet: string,
    intro_click: string,
  }) {
    let billingAmount = this.basicAmount;
    if (data.royalty_order === 'with_royalty') {
      billingAmount += this.royaltyOptionAmount;
    }
    if (data.onvocal === '1') {
      billingAmount += this.onvocalOptionAmount;
    }
    if (data.physical === '1') {
      billingAmount += this.physicalOptionAmount;
    }
    if (data.duet === '1') {
      billingAmount += this.duetOptionAmount;
    }
    if (data.intro_click === '1') {
      billingAmount += this.introClickOptionAmount;
    }
    return billingAmount;
  }
}
